import { Navigate, useLocation } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

export default function ProtectedRoute({ children, permiso }) {
  const { usuario, loading, tienePermiso } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingSpinner />;

  if (!usuario) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (permiso && !tienePermiso(permiso)) {
    return (
      <div className="oca-content">
        <div className="oca-card oca-empty">
          <ShieldAlert size={36} strokeWidth={1.5} />
          <div className="oca-empty-title">Sin permiso</div>
          <p>No tienes permiso para acceder a esta sección.</p>
        </div>
      </div>
    );
  }

  return children;
}
